import Card from "../component/Card"
import SmallHeadingComponent from "../component/SmallHeadingComponent"
import TextField from "../component/TextField"
import MoveContentToRight from "../component/MoveContentToRight"
import Button from "../component/Button"
import CenterContents from "../component/CenterContents"
import WizardComponent from "../component/WizardComponent"
import { useState } from "react"
import VerticalSpacer from "../component/VerticalSpacer"
import SelectOfficeComponent from "../component/SelectOfficeComponent"
import {
    GenerateEmailConfirmationTokenSpecification,
    SignInProfessionalSpecification,
    SignUpProfessionalSpecification
} from "pokal_api"
import notNull from "../util/notNull"
import { dispatchThunk } from "../redux/thunk/thunkify"
import { useAppDispatch } from "../redux/store/hooks"
import { useNavigate } from "react-router-dom"
import { toggleOnBoardingState } from "../redux/Onboarding"

function SignUpView() {
    const stepController = useState<number>(0)
    const [step, setCurrentStep] = stepController

    const firstNameState = useState<string>("")
    const lastNameState = useState<string>("")
    const emailState = useState<string>("")
    const passwordState = useState<string>("")
    const emailconfirmationState = useState<string>("")

    const [passwordValid, setPasswordValid] = useState<boolean>(false)

    function nextPageEnabled(): boolean {
        if (step === 0) {
            return (
                firstNameState[0] !== "" &&
                lastNameState[0] !== "" &&
                emailState[0] !== "" &&
                passwordState[0] !== "" &&
                passwordValid
            )
        } else if (step === 1) {
            return emailconfirmationState[0] !== ""
        } else {
            return true
        }
    }

    const [office, setOffice] = useState<string | null>(null)
    const dispatch = useAppDispatch()
    const navigate = useNavigate()

    function onSignUp() {
        if (nextPageEnabled() && notNull(office)) {
            SignUpProfessionalSpecification.request({
                firstName: firstNameState[0],
                lastName: lastNameState[0],
                email: emailState[0],
                password: passwordState[0],
                emailConfirmationToken: emailconfirmationState[0],
                doctorsOfficeId: office
            }).then(() =>
                dispatchThunk(
                    dispatch,
                    SignInProfessionalSpecification,
                    {
                        email: emailState[0],
                        password: passwordState[0]
                    },
                    {
                        do: () => {
                            navigate("/")
                            dispatch(toggleOnBoardingState())
                        }
                    }
                )
            )
        }
    }

    function onGenerateEmailConfirmationToken() {
        if (emailconfirmationState[0] === "") {
            GenerateEmailConfirmationTokenSpecification.request({
                email: emailState[0],
                professional: true
            })
                .then(() => setCurrentStep(1))
                .catch((e) => console.log(e))
        } else {
            setCurrentStep(2)
        }
    }

    return (
        <CenterContents>
            <Card width={step === 2 ? "100%" : undefined}>
                <WizardComponent stepController={stepController}>
                    {[
                        <div
                            key={"personal"}
                            className={"flex flex-col space-y-10"}>
                            <SmallHeadingComponent>
                                Persönliche Daten
                            </SmallHeadingComponent>
                            <TextField
                                inputState={firstNameState}
                                type={"text"}
                                placeholder={"Vorname hier eingeben"}
                                label={"Vorname"}
                            />
                            <TextField
                                inputState={lastNameState}
                                type={"text"}
                                placeholder={"Nachname hier eingeben"}
                                label={"Nachname"}
                            />
                            <TextField
                                inputState={emailState}
                                type={"text"}
                                placeholder={"Emailadresse hier eingeben"}
                                label={"Emailadresse"}
                            />
                            <TextField
                                inputState={passwordState}
                                onPasswordInvalid={() =>
                                    setPasswordValid(false)
                                }
                                onPasswordValid={() => setPasswordValid(true)}
                                type={"password"}
                                strengthControl={true}
                                placeholder={"Passwort hier eingeben"}
                                label={"Passwort"}
                            />
                            <div className={"flex flex-col space-y-4"}>
                                <div
                                    className={
                                        "max-w-[600px] italic font-bold"
                                    }>
                                    Bitte füllen Sie das nächste Feld nur aus
                                    falls Sie schon einen Bestätigungsschlüssel
                                    per Mail geschickt bekommen haben. Im
                                    Normalfall müssen Sie das Feld nicht
                                    ausfüllen.
                                </div>
                                <TextField
                                    inputState={emailconfirmationState}
                                    type={"text"}
                                    placeholder={
                                        "Bestätigungscode hier eingeben"
                                    }
                                    label={"Bestätigungscode"}
                                />
                            </div>
                            <MoveContentToRight>
                                <Button
                                    disabled={!nextPageEnabled()}
                                    onClick={onGenerateEmailConfirmationToken}>
                                    Weiter
                                </Button>
                            </MoveContentToRight>
                        </div>,
                        <div
                            key={"emailConfirmation"}
                            className={"flex flex-col space-y-10"}>
                            <SmallHeadingComponent>
                                Email-Bestätigung
                            </SmallHeadingComponent>
                            <div className={"max-w-[300px]"}>
                                Wir haben Ihnen soeben eine Bestätigungs-Mail
                                geschickt. Darin finden Sie einen 6-stelligen
                                Code den Sie im Textfeld einfügen müssen um Ihre
                                Mail-Adresse zu bestätigen.
                            </div>
                            <TextField
                                inputState={emailconfirmationState}
                                type={"text"}
                                placeholder={"Bestätigungscode hier eingeben"}
                                label={"Bestätigungscode"}
                            />
                            <MoveContentToRight>
                                <Button
                                    disabled={!nextPageEnabled()}
                                    onClick={() => setCurrentStep(2)}>
                                    Weiter
                                </Button>
                            </MoveContentToRight>
                        </div>,
                        <div key={"office"}>
                            <SmallHeadingComponent>
                                Praxis-Auswahl
                            </SmallHeadingComponent>
                            <VerticalSpacer>{20}</VerticalSpacer>
                            <SelectOfficeComponent
                                onSignUp={onSignUp}
                                selection={office}
                                setSelection={setOffice}
                                onBack={() => setCurrentStep(0)}
                            />
                        </div>
                    ]}
                </WizardComponent>
            </Card>
        </CenterContents>
    )
}

export default SignUpView
